import { translations } from '@prezly/theme-kit-intl';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { IconDownload } from 'icons';

import styles from './DownloadLink.module.scss';

interface Props {
    className: string;
}

function DownloadLink({ className }: Props) {
    return (
        <div className={classNames(styles.link, className)}>
            <FormattedMessage {...translations.actions.download} />
            <IconDownload className={styles.icon} />
        </div>
    );
}

export default DownloadLink;
